import React, { useEffect, useState } from "react";
import { api } from "../shared/axiosInstance";

const CreditTransactions = () => {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchTransactions = async () => {
            try {
                const response = await api.get("/payments/transactions");
                setTransactions(response.data);
            } catch (err) {
                console.error("Error fetching transactions:", err);
                setError("Failed to load credit transactions");
            } finally {
                setLoading(false);
            }
        };

        fetchTransactions();
    }, []);

    if (loading) return <p>Loading credit transactions...</p>;
    if (error) return <p>{error}</p>;

    return (
        <div className="p-4">
            <h2 className="text-orange text-lg font-bold mb-4">Transaction Log</h2>
            <div className="overflow-x-auto rounded border border-lightblue">
                <table className="min-w-full text-sm text-lightgray">
                    <thead>
                    <tr className="bg-deepblue text-lightblue">
                        <th className="p-3 text-left">Type</th>
                        <th className="p-3 text-left">Credits</th>
                        <th className="p-3 text-left">Amount</th>
                        <th className="p-3 text-left">Previous</th>
                        <th className="p-3 text-left">New</th>
                        <th className="p-3 text-left">User</th>
                        <th className="p-3 text-left">Description</th>
                        <th className="p-3 text-left">Date</th>
                    </tr>
                    </thead>
                    <tbody>
                    {transactions.map((tx, idx) => (
                        <tr
                            key={tx._id}
                            className={idx % 2 === 0 ? "bg-darkblue" : "bg-bluegray hover:bg-darkblue"}
                        >
                            <td className="p-3 capitalize">{tx.type}</td>
                            <td className="p-3">{tx.credits}</td>
                            <td className="p-3">${(tx.amount / 100).toFixed(2)}</td>
                            <td className="p-3">{tx.previousBalance}</td>
                            <td className="p-3">{tx.newBalance}</td>
                            <td className="p-3">
                                {tx.user ? `${tx.user.firstName} ${tx.user.lastName}` : "N/A"}
                            </td>
                            <td className="p-3">{tx.description}</td>
                            <td className="p-3">{new Date(tx.createdAt).toLocaleString()}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CreditTransactions;
